import api from "../../../api/api";

export const getTimeLagReport = (params: any) => {
  return api.get("/crm/enquiry/timelag-report/", {
    params,
  });
};
